import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';
import ScrollToTopLink from './ScrollToTopLink';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Accueil', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-gray-900 shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 md:h-28">
          <div className="flex items-center">
            <Logo variant="small" />
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8 lg:space-x-12">
            {navigation.map((item) => (
              <ScrollToTopLink
                key={item.name}
                to={item.href}
                className={`${
                  isActive(item.href)
                    ? 'text-blue-400 border-b-2 border-blue-400'
                    : 'text-gray-300 hover:text-white'
                } px-3 lg:px-4 py-3 text-sm lg:text-base font-medium transition-colors duration-200`}
              >
                {item.name}
              </ScrollToTopLink>
            ))}
            <ScrollToTopLink
              to="/contact"
              className="bg-blue-600 text-white px-4 lg:px-6 py-2 lg:py-3 rounded-md text-sm lg:text-base font-medium hover:bg-blue-700 transition-colors duration-200"
            >
              Demandez un devis
            </ScrollToTopLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white focus:outline-none"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white absolute w-full">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) => (
              <ScrollToTopLink
                key={item.name}
                to={item.href}
                className={`${
                  isActive(item.href)
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-50'
                } block px-3 py-2 rounded-md text-base font-medium`}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </ScrollToTopLink>
            ))}
            <ScrollToTopLink
              to="/contact"
              className="block w-full text-center bg-blue-600 text-white px-4 py-2 rounded-md text-base font-medium hover:bg-blue-700 transition-colors duration-200 mt-2"
              onClick={() => setIsOpen(false)}
            >
              Demandez un devis
            </ScrollToTopLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar